import { render, staticRenderFns } from "./HandoverKeysStep.vue?vue&type=template&id=ca3c2f1a&scoped=true"
import script from "./HandoverKeysStep.vue?vue&type=script&lang=ts"
export * from "./HandoverKeysStep.vue?vue&type=script&lang=ts"
import style0 from "./HandoverKeysStep.vue?vue&type=style&index=0&id=ca3c2f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3c2f1a",
  null
  
)

export default component.exports